
const PaginationBar = ({ page, totalPage, setPage, totalResult = null }) => {
    return (
        <>
            <div style={{
                display: "flex",
                flexDirection: "row",
                gap: "6px",
                margin: "15px 0",
                alignItems: "flex-end"
            }}>
                {page > 2 ? <>
                    <button onClick={() => setPage(1)} className={"el_pagination btn_pagination"}
                            style={page <= 1 ? {opacity: "50%"} : {opacity: "100%"}}
                            disabled={page <= 1}>{1}
                    </button>

                    <span>. . .</span></> : null}

                {page > 1 ?
                    <button onClick={() => setPage(parseInt(page) - 1)} className={"el_pagination btn_pagination"}
                            style={page <= 1 ? {opacity: "50%"} : {opacity: "100%"}}
                            disabled={page <= 1}>{page - 1}
                    </button> : null}

                <span className={"fake_btn_pagination el_pagination"}>{page}</span>

                {page < totalPage ?
                    <button onClick={() => setPage(parseInt(page) + 1)} className={"el_pagination btn_pagination"}
                            style={page >= totalPage ? {opacity: "50%"} : {opacity: "100%"}}
                            disabled={page >= totalPage}>{page + 1}
                    </button> : null}

                {page < totalPage - 1 ? <>
                    <span>. . .</span>

                    <button onClick={() => setPage(parseInt(totalPage))} className={"el_pagination btn_pagination"}
                            style={page >= totalPage - 1 ? {opacity: "50%"} : {opacity: "100%"}}
                            disabled={page >= totalPage - 1}>{totalPage}
                    </button>
                </> : null}
            </div>
            { totalResult && <span style={{fontSize: "0.8rem"}}>{totalResult > 1 ? totalResult+" résultats" : totalResult+" résultat"}</span> }
        </>
    );
};

export default PaginationBar;
